<template>
    <div class="row">
        <div class="col-12">
            <treatment-select v-model="innerToothOptions.treatment"
                              :technician-id="innerData.technicianId"></treatment-select>
        </div>

        <div class="col-12 text-center">
            <div class="card">
                <div class="card-header">
                    {{ $t('The color of the crowns') }}
                </div>
                <div class="card-body">
                    <div class="card card--paint d-inline-block" v-for="(tooth, index) in selectedTeeth" :key="index">
                        <div class="card-body p-3">
                            <paint v-model="innerTeethColors[tooth]"
                                   :key="tooth"
                                   width="150px"
                                   height="150px"
                            ></paint>
                            <div>
                                <span class="text-muted small">{{ $t('Tooth #') }}{{ tooth }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 mb-3 mb-md-0">
            <div class="card">
                <div class="card-header">
                    {{ $t('Completion date') }}
                </div>
                <div class="card-body">
                    <date-picker v-model="innerData.dueDate"></date-picker>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    {{ $t('Fittings') }}
                </div>
                <div class="card-body">
                    <div class="row align-items-end mb-2" v-for="(fitting, fittingIndex) in innerData.fittings"
                         :key="fittingIndex">
                        <div class="col">
                            <date-picker class="my-0" v-model="fitting.date"></date-picker>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-white mr-1"
                                    @click="removeFitting(fittingIndex)">
                                <i class="fe fe-trash"></i>
                            </button>
                            <button class="btn btn-white"
                                    :style="fittingIndex === innerData.fittings.length-1 ? {}:{'visibility': 'hidden'}"
                                    @click="addFitting()">
                                <i class="fe fe-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" v-if="innerData.fittings.length === 0">
                            <b-button class="w-100" @click="addFitting()" variant="white">
                                <i class="fe fe-plus"></i> {{ $t('Add') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    {{ $t('Image') }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <button class="btn btn-white"
                                    @click="openModal({id:'labMediaModal', multiple:true})">
                                <span class="fe fe-image mr-1"></span>
                                {{ $t("Append image") }}
                            </button>
                        </div>
                        <div class="col-12 mt-3">
                            <div class="row">
                                <div class="col-4" v-for="(image, imageIndex) in innerData.images" :key="imageIndex">
                                    <div class="card" v-if="image.image">
                                        <img :src="image.image.preview" class="card-img-top" alt="..."/>
                                        <div class="card-body p-2">
                                            <div class="row">
                                                <div class="col text-left">
                                                    <button class="btn btn-white ml-1" @click="removeImage(imageIndex)">
                                                        <i class="fe fe-trash"></i>
                                                    </button>
                                                </div>
                                                <div class="col-auto">
                                                    <button class="btn btn-white" @click="openFullImageModal(image)">
                                                        <i class="fe fe-eye"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6">
            <div class="card">
                <div class="card-header">
                    {{ $t('For sending') }}
                </div>
                <div class="card-body">
                    <div class="row mb-3" v-for="(sendingItem, index) in innerData.forSending">
                        <div class="col">
                            <b-input-group>
                                <b-form-input :placeholder="$t('Select')"
                                              v-model="sendingItem.text" type="text"
                                              :list="`sendingItemsList-${index}`">
                                </b-form-input>
                                <datalist :id="`sendingItemsList-${index}`">
                                    <option v-for="(item, index) in forSendingBasic" :key="index">
                                        {{ item.text }}
                                    </option>
                                </datalist>
                                <b-form-input class="text-center" style="max-width: 65px;"
                                              type="number" :placeholder="$t('units')" min="0"
                                              v-model="sendingItem.qty">
                                </b-form-input>
                            </b-input-group>
                        </div>

                        <div class="col-auto">
                            <button class="btn btn-white mr-1"
                                    @click="removeSendingItem(index)">
                                <i class="fe fe-trash"></i>
                            </button>
                            <button class="btn btn-white"
                                    :style="index === innerData.forSending.length-1 ? {}:{'visibility': 'hidden'}"
                                    @click="addSendinItem">
                                <i class="fe fe-plus"></i>
                            </button>
                        </div>
                    </div>
                    <template v-if="!innerData.forSending.length">
                        <div class="col-12">
                            <b-button class="w-100" @click="addSendinItem" variant="white">
                                <i class="fe fe-plus"></i> {{ $t('Add') }}
                            </b-button>
                        </div>
                    </template>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    {{ $t('Wishes') }}
                </div>
                <div class="card-body">
                    <b-form-textarea v-model="data.note"></b-form-textarea>
                </div>
            </div>
        </div>
        <media-modal category="other" :action="appendImage" id="labMediaModal"></media-modal>
        <full-image-modal id="FullImageModal"></full-image-modal>
    </div>
</template>

<script>
import Paint from "@/components/Lab/Paint/Paint";
import DatePicker from "@/components/DatePicker";
import MediaModal from "@/components/MediaModal";
import {modalMixins} from "@/mixins/modal";
import TreatmentSelect from "./TreatmentSelect";
import FullImageModal from './FullImageModal'

export default {
    name: "MainBlock",
    props: {
        selectedTeeth: Array,
        value: {type: Object, default: () => ({})},
        data: {type: Object, default: () => ({})},
        teethColors: {type: Object, default: () => ({})},
    },
    mixins: [modalMixins],
    components: {
        Paint,
        DatePicker,
        MediaModal,
        TreatmentSelect,
        FullImageModal
    },
    data() {
        return {
            forSendingBasic: [
                {text: this.$t('Spoons')},
                {text: this.$t('Screws')},
                {text: this.$t('Abutments')},
                {text: this.$t('Implants')},
                {text: this.$t('Transfers')},
                {text: this.$t('Analogues')}
            ]
        }
    },
    methods: {
        addFitting() {
            const previousFitting = this.innerData.fittings[this.innerData.fittings.length - 1];
            const date = previousFitting ? this.$moment(previousFitting.date).add(1, 'day').format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD');
            this.innerData.fittings.push({date});
        },

        removeFitting(index) {
            this.innerData.fittings.splice(index, 1)
        },

        addSendinItem() {
            this.innerData.forSending.push({text: '', qty: ''})
        },
        removeSendingItem(index) {
            this.innerData.forSending.splice(index, 1)
        },

        appendImage(image) {
            if (!this.innerData.images) this.$set(this.innerData, 'images', [])
            this.innerData.images.push({image_id: image._id, image: image})
        },

        removeImage(index) {
            this.innerData.images.splice(index, 1)
        },

        openFullImageModal(image) {
            const {Medium} = this.$FeathersVuex;
            new Medium({
                image,
                _id: 'temp'
            });
            this.openModal({id: 'FullImageModal'});
        },
    },
    computed: {
        innerToothOptions: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        },
        innerData: {
            get() {
                return this.data
            },
            set(value) {
                this.$emit('update:data', value)
            }
        },
        innerTeethColors: {
            get() {
                return this.teethColors
            },
            set(value) {
                this.$emit('update:teethColors', value)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.card {
    &--paint {
        position: relative;
        transition: transform .15s linear;
        z-index: 0;
        margin-right: 30px;
        &:last-child {
            margin-right: 0;
        }

        &:hover {
            transform: scale(1.4);
            z-index: 1;
        }
    }
}
</style>
